import { render, staticRenderFns } from "./order-bom.vue?vue&type=template&id=2c135862&scoped=true&"
import script from "./order-bom.vue?vue&type=script&lang=js&"
export * from "./order-bom.vue?vue&type=script&lang=js&"
import style0 from "./order-bom.vue?vue&type=style&index=0&id=2c135862&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c135862",
  null
  
)

export default component.exports